import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'filename', 'error', 'iconUpload', 'iconDone'];
  static values = { maxSize: Number, allowedTypes: Array, emptyLabel: String };

  highlight() {
    this.element.classList.add('is-dragover');
  }

  unhighlight() {
    this.element.classList.remove('is-dragover');
  }

  drop(event) {
    this.unhighlight();

    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles.length === 0) return;

    // Un RIB est un document unique : on ne garde que le premier fichier déposé.
    const singleFile = new DataTransfer();
    singleFile.items.add(droppedFiles[0]);
    this.inputTarget.files = singleFile.files;
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }

  validate() {
    const file = this.inputTarget.files[0];

    this.#reset();
    if (file === undefined) return;

    if (!this.#isAcceptable(file)) {
      this.inputTarget.value = '';
      this.inputTarget.setAttribute('aria-invalid', 'true');
      this.element.classList.add('is-error');
      this.errorTarget.classList.remove('d-none');
      return;
    }

    this.filenameTarget.textContent = file.name;
    this.element.classList.add('is-done');
    this.iconUploadTarget.classList.add('d-none');
    this.iconDoneTarget.classList.remove('d-none');
  }

  #reset() {
    this.element.classList.remove('is-done', 'is-error');
    this.inputTarget.removeAttribute('aria-invalid');
    this.errorTarget.classList.add('d-none');
    this.iconUploadTarget.classList.remove('d-none');
    this.iconDoneTarget.classList.add('d-none');
    this.filenameTarget.textContent = this.emptyLabelValue;
  }

  #isAcceptable(file) {
    return file.size <= this.maxSizeValue && this.allowedTypesValue.includes(file.type);
  }
}
